import { useEffect } from "react";
import { useIonAlert } from "@ionic/react";
import { Capacitor } from "@capacitor/core";
import { AppLauncher } from "@capacitor/app-launcher";
import { AppSettings } from "@core/types";
import { getAppConfig } from "@core/config";
import { useConfig } from "../providers/config";
import { App as AppPlugin } from "@capacitor/app";
import { useTranslation } from "react-i18next";

const codeBaseVersion = process.env.REACT_APP_PARHATO_CODE_VERSION!;

const useVersionCheck = () => {
  const config = useConfig();
  const [presentAlert] = useIonAlert();
  const { t } = useTranslation();

  useEffect(() => {
    const showAlert = async (settings: AppSettings) => {
      const appInfo = await AppPlugin.getInfo();

      const isIOS = Capacitor.getPlatform() === "ios";

      let minVersion = isIOS ? Number(settings.minVersionIOS) : Number(settings.minVersionAndroid);

      if (Number(codeBaseVersion) < minVersion) {
        const toMarketUrl = isIOS
          ? `itms-apps://itunes.apple.com/app/${getAppConfig().appIosId}`
          : `market://details?id=${appInfo.id}`;
        presentAlert({
          header: settings.newVersionAlertTitle ?? t("Please update the app"),
          message: settings.newVersionAlertMessage ?? t("A new version has been released..."),
          backdropDismiss: false,
          keyboardClose: false,
          buttons: [
            {
              text: settings.newVersionAlertButtonText ?? t("Update"),
              handler: () => {
                AppLauncher.openUrl({ url: toMarketUrl });
                return false;
              },
            },
          ],
        });
      }
    };

    if (config && config.showNewVersionAlert && Capacitor.isNativePlatform()) {
      showAlert(config);
    }
  }, [config, presentAlert]);
};

export default useVersionCheck;